import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { mdiCheckCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import SpinnerEllipsis from 'components/atoms/SpinnerEllipsis'
import { useWizard } from 'react-use-wizard'
import { DocumentAddStep } from '../model'

interface StepFinishProps {
  uploading: boolean
  onFinish: () => void
  error: boolean
}

const StepFinish = ({
  uploading,
  onFinish,
  error
}: StepFinishProps): JSX.Element => {
  const { previousStep } = useWizard()
  const renderWaitMessage = (): JSX.Element => {
    return (
      <SpinnerEllipsis
        showText={true}
        text='Submitting documents to your attorney'
      />
    )
  }

  if (!uploading && error) {
    previousStep(DocumentAddStep.SubmitFiles)
  } else if (!uploading && !error) {
    setTimeout(() => {
      onFinish()
    }, 4000)
  }

  const renderCompleteMessage = (): JSX.Element => {
    return (
      <React.Fragment>
        <Row>
          <Col className='text-center'>
            <Icon path={mdiCheckCircleOutline} size={2} color='#16A550' />
            <h3 className='mt-3'>
              Your documents have been successfully submitted!
            </h3>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Container className='mb-3'>
        {uploading ? renderWaitMessage() : renderCompleteMessage()}
      </Container>
    </React.Fragment>
  )
}

export default StepFinish
